import { FontFamilyKind } from '../Model/FontFamilyKind';
import { FontFamily } from '../Model/FontFamily';
var FontFamilyHelper = /** @class */ (function () {
    function FontFamilyHelper() {
    }
    FontFamilyHelper.getFont = function (kind) {
        for (var index in this.fonts) {
            if (this.fonts[index].kind === kind) {
                return this.fonts[index];
            }
        }
        return this.fonts[0];
    };
    FontFamilyHelper.fonts = [
        new FontFamily(FontFamilyKind.Arial, 'Arial', 'Arial, Helvetica, Tahoma, "Open Sans", sans-serif'),
        new FontFamily(FontFamilyKind.EBGaramond, 'EB Garamond', '"EB Garamond", "PT Serif", Times, "Times New Roman", serif'),
        new FontFamily(FontFamilyKind.FranklinGothicDemi, 'Franklin Gothic Demi', '"Franklin Gothic Demi", Roboto, Verdana, "Open Sans", sans-serif'),
        new FontFamily(FontFamilyKind.Georgia, 'Georgia', 'Georgia, "Times New Roman", Lora, "PT Serif", serif'),
        new FontFamily(FontFamilyKind.Helvetica, 'Helvetica', 'Helvetica, Arial, "PT Sans", Lato, sans-serif'),
        new FontFamily(FontFamilyKind.Lato, 'Lato', 'Lato, "PT Sans", Arial, Helvetica, sans-Serif'),
        new FontFamily(FontFamilyKind.Lora, 'Lora', 'Lora, "Roboto Slab", Georgia, "PT Serif", serif'),
        new FontFamily(FontFamilyKind.NotoSans, 'Noto Sans', '"Noto Sans", Helvetica, Arial, "PT Sans", sans-serif'),
        new FontFamily(FontFamilyKind.NotoSerif, 'Noto Serif', '"Noto Serif", "PT Serif", Times, "Times New Roman", serif'),
        new FontFamily(FontFamilyKind.OpenSans, 'Open Sans', '"Open Sans", "PT Sans", Tahoma, Helvetica, sans-serif'),
        new FontFamily(FontFamilyKind.PTSans, 'PT Sans', '"PT Sans", "Open Sans", Arial, Tahoma, sans-serif'),
        new FontFamily(FontFamilyKind.PTSerif, 'PT Serif', '"PT Serif", "Noto Serif", Times, "Times New Roman", serif'),
        new FontFamily(FontFamilyKind.Roboto, 'Roboto', 'Roboto, Ubuntu, Arial, Tahoma, sans-serif'),
        new FontFamily(FontFamilyKind.RobotoSlab, 'Roboto Slab', '"Roboto Slab", Lora, Georgia, "PT Serif", serif'),
        new FontFamily(FontFamilyKind.Tahoma, 'Tahoma', 'Tahoma, "PT Sans", Ubuntu, Arial, sans-serif'),
        new FontFamily(FontFamilyKind.TimesNewRoman, 'Times New Roman', '"Times New Roman", Times, Georgia, "PT Serif", serif'),
        new FontFamily(FontFamilyKind.Ubuntu, 'Ubuntu', 'Ubuntu, Roboto, "Open Sans", Tahoma, sans-serif'),
        new FontFamily(FontFamilyKind.Verdana, 'Verdana', 'Verdana, Ubuntu, Roboto, Tahoma, sans-serif')
    ];
    return FontFamilyHelper;
}());
export { FontFamilyHelper };
